import React, { useEffect } from 'react';

import Helmet from 'react-helmet';
import pickBy from 'lodash/pickBy';
import env from '@upgrade/ui-utils/env';
import loadScript from '@upgrade/ui-utils/utils/load-script';

const siteUrl = 'https://www.upgrade.com';

const defaults = {
  title: 'Upgrade - Affordable Online Personal Loans',
  description:
    'Check your rate for a low fixed-rate personal loan in just minutes. Borrow up to $50,000 with no prepayment penalties. Checking your rate has no impact to your credit score.',
  image: '/img/hero-lake.jpg',
  type: 'website',
  url: '/'
};

const prefix = url => (url.indexOf('http') === 0 ? url : `${siteUrl}${url}`);

export default props => {
  // Like _.defaults, but where the empty strings/falsy values in the provided object are ignored.
  const seo = { ...defaults, ...pickBy(props) };
  const { title, description, image, type, url, blockRobots, injectSumo } = seo;
  const link = prefix(url);
  const img = prefix(image);

  useEffect(() => {
    if (injectSumo && process.env.GATSBY_SUMO_SITE_ID) {
      loadScript('//load.sumo.com/', {
        attributes: {
          'data-sumo-site-id': process.env.GATSBY_SUMO_SITE_ID
        }
      }).catch(e => console && console.error(e));
    }
  }, [injectSumo]);

  return (
    <Helmet
      title={title}
      link={[{ rel: 'canonical', href: link }]}
      meta={[
        { name: 'description', content: description },
        // Open graph
        { property: 'og:title', content: title },
        { property: 'og:type', content: type },
        { property: 'og:url', content: link },
        { property: 'og:image', content: img },
        { property: 'og:description', content: description },
        // Twitter
        { name: 'twitter:card', content: 'summary' },
        { name: 'twitter:title', content: title },
        { name: 'twitter:description', content: description },
        { name: 'twitter:image', content: img },
        {
          name: 'robots',
          content: blockRobots
            ? 'none'
            : env.GATSBY_ROBOT_CONTENT_POLICY || process.env.GATSBY_ROBOT_CONTENT_POLICY || 'all'
        },
        {
          name: 'facebook-domain-verification',
          content: env.GATSBY_FACEBOOK_DOMAIN_KEY || process.env.GATSBY_FACEBOOK_DOMAIN_KEY
        }
      ]}
    >
      {props.children}
    </Helmet>
  );
};
